import axios from "axios";
import { Base_URL2 } from "../url";

export const getTableNames = async () => {
  const res = await axios.get(`${Base_URL2}/AudiLog/GetAllTableNames`);
  return res.data;
};

export const getOrganisations = async () => {
  const res = await axios.get(`${Base_URL2}/AudiLog/GetAllOrganisations`);
  return res.data;
};

export const getCompanyCodes = async (orgId) => {
  const res = await axios.get(
    `${Base_URL2}/AudiLog/GetAllCompanyCodesForOrg/${orgId}`
  );
  return res.data;
};

export const saveConfig=async (payload)=>{
    const res=await axios.post(`${Base_URL2}/AudiLog/InsertIntoAuditLogConfig`,payload);
    return res.data;
}
export const getColumnsByTable = async (tableName) => {
  const res = await axios.get(
    `${Base_URL2}/AudiLog/GetColumnNamesOftable/${tableName}`
  );
  return res.data;
};

export const saveFieldConfig = async (payload) => {
  const res = await axios.post(`${Base_URL2}/AudiLog/InsertIntoAuditFieldConfig`, payload);
  return res.data;
}

export const getTableConfig = async (tableName) => {
  const res = await axios.get(`${Base_URL2}/AudiLog/GetTableConfigFromName/${tableName}`);
  return res.data;
}